import {
	ApiUtils,
	_axios
}from '@/api/apiUtil.js';
import constant from '@/util/constant.js';
const api = {

	list: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/consu/consuxl/list", params, successCallback, failCallback, exceptionCallback);
	},save: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/consu/consuxl/save", params, successCallback, failCallback, exceptionCallback);
	},remove: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/consu/consuxl/remove", params, successCallback, failCallback, exceptionCallback);
	},listRcds: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/consu/consuxl/listRcds", params, successCallback, failCallback, exceptionCallback);
	},attact: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/consu/consuxl/attact", params, successCallback, failCallback, exceptionCallback);
	},update: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.putLoadingAjax(constant.serverUrl + "/consu/consuxl/update", params, successCallback, failCallback, exceptionCallback);
	},delRecordByRid: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/consu/consuxl/delRecordByRid", params, successCallback, failCallback, exceptionCallback);
	},toUpdate: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/consu/consuxl/toUpdate", params, successCallback, failCallback, exceptionCallback);
	},list4Dispatch: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/consu/consuxl/ls4Dispatch", params, successCallback, failCallback, exceptionCallback);
	},dspConus: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/consu/consuxl/dspConus", params, successCallback, failCallback, exceptionCallback);
	},upDatatoFront: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.deleteLoadingAjax(constant.serverUrl + "/consu/consuxl/upDatatoFront", params, successCallback, failCallback, exceptionCallback);
	},oneConus: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/consu/consuxl/oneConus", params, successCallback, failCallback, exceptionCallback);
	},toPush: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.getLoadingAjax(constant.serverUrl + "/consu/consu/toPush", params, successCallback, failCallback, exceptionCallback);
	},importData: (params, successCallback, failCallback, exceptionCallback) => {
		ApiUtils.postLoadingAjax(constant.serverUrl + "/consu/consuxl/import", params, successCallback, failCallback, exceptionCallback);
	}
}

export default api;
